import { render, staticRenderFns } from "./CurrentPayables.vue?vue&type=template&id=8d33984a&"
import script from "./CurrentPayables.vue?vue&type=script&lang=js&"
export * from "./CurrentPayables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports